"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Gallery Spacing',
  description: "Set the margin between the gallery and it's container.",
  isRelevant: function isRelevant(styleParams) {
    return true;
  },
  type: _constants.INPUT_TYPES.NUMBER,
  "default": 0
};
exports["default"] = _default;